/*!
 *
 *	slide-scroll.js
 *
 */

var slideScroll = function( options ){
	var opt = options || {};
	var settings = {
		easing : 'fast',
		speed : 300,
		not: null
	};
	settings = $.extend( settings, opt );

	var $a = $('a[href^="#"], a[href^="'+ location.pathname +'#"], a[href^="'+ location.protocol + '//' + location.hostname + location.pathname +'#"]').not('[href="#"]').not(''+settings.not );
	var _slider = origin.st;

	$a.on('tap', function(e){
		e.preventDefault();
		var _target = $(this).attr('href');
		_target = _target.replace(location.protocol + '//' + location.hostname + location.pathname, '').replace( location.pathname, '');
		var _pos = $(_target).offset().top;

		var _span = 90;
		if( origin.VPisMobile ){
			_span = 60;
		};
		var __pos;
		if( _pos > origin.switchPoint ){
			__pos = _pos - _span;
		}else{
			__pos = _pos;
		};

		$(_slider).animate({
			scrollTop : __pos
		},{
			duration : settings.speed,
			easing : settings.easing,
			queue : false
		});
		return false;
	});
};

module.exports = slideScroll;


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/slide-scroll.js
// module id = 13
// module chunks = 0